var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',[_c('dt',[_vm._v(_vm._s(_vm.label))]),_c('dd',[_vm._v(_vm._s(_vm._f("runFilter")(_vm.subjectValue,_vm.subjectFilter)))]),_c('dd',[_vm._v(_vm._s(_vm._f("runFilter")(_vm.partnerValue,_vm.partnerFilter)))])])}
var staticRenderFns = []

export { render, staticRenderFns }